angular.module('impactx.cancellation').controller('CRHBuyerListCtrl', CRHBuyerListCtrl);

CRHBuyerListCtrl.$inject = ['selectedListItems'];

function CRHBuyerListCtrl(selectedListItems)
{
    var self = this;

    self.getDetailLink = function () {
        return 'crhdetails/' + selectedListItems.getFirstSelectedId();
    };

    self.showDetailButton = function () {
        return selectedListItems.isSingleSelection();
    };

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: self.getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'PurchaseOrderView'
        }
    ];

    this.meta = {
        rowTemplate: 'modules/cancellation/templates/crhlistbuyer.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/cancellationrequest/list/buyer',
        id: "crhlistbuyer",
        excelExport: true,
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function () {
        return this.meta;
    };
}